<div class="rating-modal">
  <h2 class="rating-modal__title">¿Qué te ha parecido la clase?</h2>
  <p class="rating-modal__subtitle">Deja una reseña sobre qué te ha parecido la clase.</p>

  <div class="rating-modal__stars" (mouseleave)="onStarLeave()">
    @for (star of stars; track star) {
      <app-enfaf-icon
        [isButton]="true"
        [svgIconName]="star <= (hoveredStar() || rating()) ? 'star-blue-fill' : 'star-blue-empty'"
        iconSize="56px"
        (onClick)="onStarClick(star)"
        (mouseenter)="onStarHover(star)"
      ></app-enfaf-icon>
      <!-- <mat-icon
        class="rating-modal__star"
        [class.rating-modal__star--filled]="star <= (hoveredStar() || rating())"
        (click)="onStarClick(star)"
        (mouseenter)="onStarHover(star)">
        {{ star <= (hoveredStar() || rating()) ? 'star' : 'star_border' }}
      </mat-icon> -->
    }
  </div>

  <div class="rating-modal__comment-field">
    <app-enfaf-textarea-light
      label="Descripción detallada (opcional)"
      placeholder=""
      title="Descripción detallada"
      [control]="commentControl"
      [expandable]="false"
      [height]="110"
      [width]="408"
      [rows]="3"
      [maxLength]="2000"
      autocomplete="off"
      errorLabel=""
    ></app-enfaf-textarea-light>
  </div>

  <div class="rating-modal__actions">
    <app-enfaf-button type="modal-outline" [disabled]="isSubmitting()" (onClick)="onSkip()">Saltar</app-enfaf-button>
    <app-enfaf-button type="modal-primary" [disabled]="rating() === 0 || isSubmitting()" (onClick)="onSubmit()">Enviar</app-enfaf-button>
  </div>
</div>
